import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import introspection from '../generated/graphql.api-app';

/** `possibleTypes` lets the cache match a union's fragments, e.g. MoveResult's `... on Game`. */
export const apolloCache = new InMemoryCache({ possibleTypes: introspection.possibleTypes });

export const apolloClient = new ApolloClient({
  link: createHttpLink({
    credentials: 'include',
    uri: API_URL,
  }),
  cache: apolloCache,
  devtools: {
    enabled: true,
  },
});
